// Discord-style link to a channel: https://iopta.org/channels/{groupId}/{channelId} — what «Копировать
// ссылку» copies. Clicked inside a message it opens the channel in the app (useMarkdownContentClick.ts)
// instead of the browser; opening it from outside the app needs the site and deep links to handle it.
const CHANNEL_URL_BASE = 'https://iopta.org/channels'
const CHANNEL_URL_RE = /^https?:\/\/(?:www\.)?iopta\.org\/channels\/([0-9a-f-]{36})\/([0-9a-f-]{36})\/?(?:[?#].*)?$/i

export function buildChannelUrl(groupId: string, channelId: string): string {
  return `${CHANNEL_URL_BASE}/${groupId}/${channelId}`
}

export function parseChannelUrl(href: string): { groupId: string, channelId: string } | null {
  const match = CHANNEL_URL_RE.exec(href)
  return match ? { groupId: match[1]!, channelId: match[2]! } : null
}
